import React, { Component } from 'react';
import PropTypes from "prop-types";

import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import config from 'config';
import JsonLD from 'modules/Common/components/JsonLD';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

import {singleBottomMPUProps} from '../../Common/components/GptProperties';

@catchLifeCycleErrors
export default class Home extends Component {
  static propTypes = {
    MoreNews: PropTypes.element.isRequired,
    AdvertWrapper: PropTypes.element.isRequired,
    HomeColumnists: PropTypes.element.isRequired,
    MostReadAll: PropTypes.element.isRequired,
    RacingTips: PropTypes.element.isRequired,
    HorseRacingNextRaceOff: PropTypes.element.isRequired,
    FootballTips: PropTypes.element.isRequired,
    InsiderMpu: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    require('./HomePage.scss');
    const {
      location,
      MoreNews,
      HomeColumnists,
      AdvertWrapper,
      MostReadAll,
      RacingTips,
      InsiderMpu,
      HorseRacingNextRaceOff,
      FootballTips,
      GooglePublisherTag
    } = this.props;

    return (
      <StandardPage sport="racing" title={config.pageTitle.default}>
        <JsonLD data={{
          "@type": "WebSite",
          "@id": "https://www.sportinglife.com",
          url: "https://www.sportinglife.com",
          name: "Sporting Life",
          sameAs: [
            "https://www.facebook.com/SportingLifeOfficial",
            "https://twitter.com/SportingLife",
            "https://soundcloud.com/sportinglife",
            "https://en.wikipedia.org/wiki/Sporting_Life_(British_newspaper)",
            "https://www.wikidata.org/wiki/Q7579580"
          ]
        }} />

        <div className="main-layout-left-column">
          <div id="left-more-news" className="main-layout-block">
            {MoreNews}
          </div>
          <div className="main-layout-block">
            {AdvertWrapper &&
              React.cloneElement(AdvertWrapper, {
                ocSlot: ["homepage", "leaderboard"],
                additionalProperties: {view: "home-page"}
              })
            }
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {MostReadAll}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {RacingTips}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {InsiderMpu}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {HorseRacingNextRaceOff}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {AdvertWrapper &&
              React.cloneElement(AdvertWrapper, {
                ocSlot: ["racing", "leaderboard"],
                additionalProperties: {view: "home-page"}
              })
            }
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {FootballTips}
          </div>
          <div className="main-layout-block main-layout-hide-desktop">
            {AdvertWrapper &&
              React.cloneElement(AdvertWrapper, {
                ocSlot: ["football", "leaderboard"],
                additionalProperties: {view: "home-page"}
              })
            }
          </div>
          <div className="main-layout-block last-desktop">
            {HomeColumnists}
          </div>
          <div className="main-layout-block last-handheld main-layout-hide-desktop">
            {GooglePublisherTag &&
              React.cloneElement(GooglePublisherTag, singleBottomMPUProps)
            }
          </div>
          <div>

          </div>
        </div>

        <RightColumn location={location}
                     sport="homepage"
                     content={[
                       "racingTips",
                       "insiderMpu",
                       "topMpu",
                       "mostReadAll",
                       "horseRacingNextRaceOff",
                       "footballTips",
                       "ocWidget",
                       "bottomMpu"]} />
      </StandardPage>

    );
  }
}



// WEBPACK FOOTER //
// ./modules/Home/containers/HomePage.js